import { render } from "./HiFireDocTagger.vue?vue&type=template&id=38196f6f"
import script from "./HiFireDocTagger.vue?vue&type=script&lang=js"
export * from "./HiFireDocTagger.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__